import { ElementFactory } from "survey-core";

// Disable the tagbox (multi dropdown list) question type added in SurveyJS 1.9.114
export function removeTagboxType() {
    // Remove the tagbox element from the ElementFactory
    // This prevents it from appearing in the question type options
    if (ElementFactory.Instance.getAllTypes().includes("tagbox")) {
        ElementFactory.Instance.unregisterElement("tagbox", true);
    }
}